module.exports = __webpack_public_path__ + "static/media/image1.932cf2c3.png";